
import React, { Component } from 'react';
import { connect } from 'react-redux';
import CartItem from '../Cart/cartItem';

class CartList extends Component {

    constructor(props){
        super(props);
        this.state = {};
    }

    render() {
        return(
            <tbody>
                {
                    this.props.carrito.map((prod, index) => {
                        return (
                            <CartItem key={index} item={prod} />
                        );
                    })
                }
            </tbody>
        );
    }

}

function mapStateToProps(state) {
    return {
        carrito: state.carrito,
        count: state.carrito_count
    };
};

export default connect(mapStateToProps)(CartList);


// WEBPACK FOOTER //
// ./src/components/Cart/cartList.js